module.exports = __webpack_public_path__ + "img/fujian.033e4435.jpg";